"use client";

import React, { useState } from 'react';
import { Badge } from "flowbite-react";
import { Button, Select, Table, Typography, Pagination, Input } from 'antd'
import { MdFilterListAlt } from "react-icons/md";
import { Link, useLoaderData, useNavigate } from 'react-router-dom';

const columns = [
  {
    title: '',
    dataIndex: 'date',
    key: 'date',
    width: '50px',
    className: 'whitespace-nowrap text-[#189aa0] dark:text-white',
    render: (_, record) => <>
      <span className='font-semibold'><span className='font-bold'>{record.date}</span>{record.reference}</span>
    </>
  },
  {
    title: 'Account',
    dataIndex: 'account',
    key: 'account',
    ellipsis: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Label',
    dataIndex: 'label',
    key: 'label',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Debit',
    dataIndex: 'debit',
    key: 'debit',
    // width: '150px',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    align: 'right',
    render: (_, record) => <span>{ new Intl.NumberFormat('en-Gh', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(record.debit) +' GHc'}</span>
  },
  {
    title: 'Credit',
    dataIndex: 'credit',
    key: 'credit',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    // width: '150px',
    align: 'right',
    render: (_, record) => <span>{new Intl.NumberFormat('en-Gh', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(record.credit) + ' GHc' }</span>
  },

]


const options = []
for (let i = 10; i < 36; i++) {
  options.push({
    value: i.toString(36) + i,
    label: i.toString(36) + i
  })
}
const handleChange = (value) => {
  console.log(`Selected: ${value}`)
}



const JournalItemsType = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const journalItems = useLoaderData();
  const navigate = useNavigate();
  const [current, setCurrent] = useState(3)
  const onChange = (page) => {
    console.log(page)
    setCurrent(page)
  }


  // const onRow = (record, rowIndex) => {
  //   return {
  //     onClick: () => navigate('/accounting/journal-entries/'+record.number.replaceAll('/', '-'))
  //   };
  // }


  return (
    <div>
      {/* <div className='flex justify-between mx-4'>
        <h3 className='font-bold'>Journal Entries</h3>
        <div class=" bg-white dark:bg-gray-900">
          <label for="table-search" class="sr-only">Search</label>
          <div class="relative mt-1">
            <div class="absolute inset-y-0 rtl:inset-r-0 start-0 flex items-center ps-3 pointer-events-none">
              <svg class="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"/>
              </svg>
            </div>
            <input type="text" id="table-search" class="block pt-2 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg w-80 bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Search for items" />
          </div>
        </div>
      </div> */}
      <div className='flex justify-between mx-4'>
        <h3 className='font-bold'>Journals Items</h3>
        <div className=' bg-white dark:bg-gray-900'>
          {/* <Input addonBefore={<MdFilterAlt />}  defaultValue="mysite" /> */}

          <Select
            mode='multiple'
            size={'middle'}
            placeholder='Filter'
            // defaultValue={['a10', 'c12']}
            onChange={handleChange}
            className='w-96'
            options={options}
          />
        </div>
      </div>
      <div className='flex justify-end mx-4 my-2'>

        <div className='dark:bg-gray-900 '>
          <div className='flex justify-end'>
            <Pagination current={current} onChange={onChange} total={50} />
          </div>
        </div>
      </div>
      <Table
        // sticky
        // onRow={onRow}
        rowClassName={'hover:cursor-pointer'}
        dataSource={journalItems}
        columns={columns}
        scroll={{ x: 1500 }}
        pagination={false}
        rowKey={'id'}
        expandable={{
          expandRowByClick: true
        }}
      />
    </div>
  )
}

export default JournalItemsType;